var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[(_vm.loginUserInfo.auth_ref_order)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'order' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferOrder',
          'loadHTML_forReferOrder',
          {},
          '',
          '/reference/order.html'
        )}}},[_vm._v("ご発注確認")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_orderrest)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'order_rest' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferOrderRest',
          'loadHTML_forReferOrderRest',
          {},
          '',
          '/reference/order_rest.html'
        )}}},[_vm._v("ご発注残確認")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_purchaseresults)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'purchase_results' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferPurchaseResults',
          'loadHTML_forReferPurchaseResults',
          {},
          '',
          '/reference/purchase_results.html'
        )}}},[_vm._v("仕入実績")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_inventory)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'inventory' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferInventory',
          'loadHTML_forReferInventory',
          {},
          '',
          '/reference/inventory.html'
        )}}},[_vm._v("在庫照会")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_deliveryslip)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'delivery_slip' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferDeliverySlip',
          'loadHTML_forReferDeliverySlip',
          {},
          '',
          '/reference/delivery_slip.html'
        )}}},[_vm._v("納品書")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_itemprice)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'item_price' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferItemPrice',
          'loadHTML_forReferItemPrice',
          {},
          '',
          '/reference/item_price.html'
        )}}},[_vm._v("価格照会")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_invoice)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'bill' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferBill',
          'loadHTML_forReferBill',
          {},
          '',
          '/reference/bill.html'
        )}}},[_vm._v("請求書")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_printableitem)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'printable_item' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferPrintableItem',
          'loadHTML_forReferPrintableItem',
          {},
          '',
          '/reference/printable_item.html'
        )}}},[_vm._v("印刷品確認")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_accounts_payable)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'payable' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferPayable',
          'loadHTML_forReferPayable',
          {},
          '',
          '/reference/payable.html'
        )}}},[_vm._v("貴社請求書")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_csvhistory)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'csv_history' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferCSVHistory',
          'loadHTML_forCsvHistory',
          {},
          '',
          '/reference/csv_history.html'
        )}}},[_vm._v("取込出力履歴")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_productmaster)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active === 'product_master' },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'ReferProductMaster',
          'loadHTML_forReferProductMaster',
          {},
          '',
          '/reference/product_master.html'
        )}}},[_vm._v("商品マスタ照会")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }